class TimedTab {
    constructor(timedSlider) {
        this.timedSlider = timedSlider
        this.navigation = this.timedSlider.querySelector('.timed-slider-navigation')
        this.glideConfiguration = JSON.parse(this.timedSlider.dataset.configuration)
        this.isAutoplayEnabled = this.glideConfiguration.default.autoplay !== false
        this.timedSlider.addEventListener('beforeGlideMount', (e) => this.onBeforeGlideMount(e))
    }

    onBeforeGlideMount(e) {
        const glide = e.detail
        this.glideInstance = e.detail

        // only observe if an autoplay duration is set
        if (this.isAutoplayEnabled) this.addInViewportObserver()

        glide.on('mount.before', () => {
            if (this.isAutoplayEnabled) {
                this.initNavigationIndicatorAnimation()
            }
        })
    }

    addInViewportObserver() {
        const inViewportObserver = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    this.changeBtnAnimationStatus(entry.isIntersecting)
                })
            },
            {
                rootMargin: '0px 0px 0px 0px',
                threshold: 0.5, // half of item height
            }
        )
        inViewportObserver.observe(this.timedSlider)
    }

    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }

    initNavigationIndicatorAnimation() {
        if (this.isMobileDevice()) {
            this.timedSlider.addEventListener('click', () => {
                this.changeBtnAnimationStatus(true)
            })
        } else {
            this.timedSlider.addEventListener('mouseover', () => {
                this.changeBtnAnimationStatus(false)
            })
            this.timedSlider.addEventListener('mouseout', () => {
                this.changeBtnAnimationStatus(true)
            })
            this.changeBtnAnimationStatus(true)
        }
    }

    changeBtnAnimationStatus(newStatus = true) {
        this.navigation.classList.toggle('animate', newStatus)
        if (newStatus) {
            this.glideInstance.play()
        } else {
            this.glideInstance.pause()
        }
    }
}

function initTimedTabs() {
    const TimedSliders = document.querySelectorAll('.timed-slider .glide')
    TimedSliders.forEach((timedSlider) => new TimedTab(timedSlider))
}

if (document.readyState !== 'loading') {
    initTimedTabs()
} else {
    document.addEventListener('DOMContentLoaded', initTimedTabs)
}
